import { Component, Input } from '@angular/core';
import { PropertiesSettings } from '../../../../core/configuration/properties-settings';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';
import { Pratica } from 'src/app/common/models/pratica/pratica';

@Component({
    selector: 'div [dati-fascicolo-view]',
  templateUrl: 'dati-fascicolo-view.component.html',
})
//
export class DatiFascicoloComponent {
  isProtocolEnabled: boolean=false;
  constructor(private configService: ConfigurationService) {
    this.isProtocolEnabled = this.configService.isFeatureEnabled(ConfigurationFeature.PROTOCOL);
  }
  @Input() fascicolo: FascicoloFull;
  @Input() isSchedaAnalitica:boolean=false;
  @Input() pratica:Pratica;
  labelCreatoDaSistema: string = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;
}
